import { getProgressPageIndex } from "../../helpers";
export function onDragStart(state) {
    state.autoLoopStop();
    state.setDragging(true);
}
export function onDragEnd(state) {
    state.setDragging(false);
    state.setClicked(true);
}
export function onThrowComplete(state) {
    state.setAnimationX(this.x);
    state.updateCurrentPage(getProgressPageIndex(state.calcs, this.x));
}
//# sourceMappingURL=draggableCallbacks.js.map